import React from "react";
import Text from "common/Typography/Text.tsx";
import { ItemType } from "antd/es/menu/interface";
import styled from "styled-components";

interface DropdownOptionProps {
  item: ItemType;
  setShouldCloseDrawer?: (shouldCloseDrawer: boolean) => void;
}

const DropdownOption = ({
  item,
  setShouldCloseDrawer,
}: DropdownOptionProps) => {
  if (item === null) return;
  if ("type" in item && item.type === "divider") {
    return <Divider />;
  }

  const showIcon = "icon" in item;

  return (
    <Option
      as="div"
      key={item.key}
      onClick={(e) => {
        setShouldCloseDrawer?.(true);
        if ("onClick" in item) {
          item.onClick?.({
            key: String(item.key),
            keyPath: [String(item.key)],
            item: null as any,
            domEvent: e,
          });
        }
      }}
      className={`mobile-dropdown-menu-item ${item.className}`}
    >
      {showIcon && item.icon}
      <span style={{ marginLeft: showIcon ? 8 : 0 }}>{item.label}</span>
    </Option>
  );
};

export default React.memo(DropdownOption);

const Option = styled(Text)`
  display: flex;
  align-items: center;
`;
const Divider = styled.div`
  height: 1px;
  background: ${(p) => p.theme.colors.lightBorderGrey};
  width: 100%;
`;
